import type { SupportedCountryCode } from '@seek/ca-myprofile-utils';
import { mapDropdownItemToOption } from '@seek/profile-edit-ui';
import { useTranslations } from '@vocab/react';
import { Dropdown } from 'braid-design-system';
import type React from 'react';

import translations from './.vocab';
import { useRightToWorkOptionsByCountryCode } from './data';

interface ComponentProps {
  value?: string;
  countryCode: SupportedCountryCode;
  rtwUpdate: (value: string) => void;
  label?: string;
  rightToWorkRef?: React.RefObject<HTMLSelectElement>;
}

export const RightToWorkDropdown = ({
  value,
  countryCode,
  rtwUpdate,
  label,
  rightToWorkRef,
}: ComponentProps) => {
  const { t } = useTranslations(translations);
  const handleTypeChange = (event: React.FormEvent<HTMLSelectElement>) => {
    rtwUpdate(event.currentTarget.value);
  };

  const { rightToWorkDropdownOptions } =
    useRightToWorkOptionsByCountryCode(countryCode);

  const optionValue = rightToWorkDropdownOptions.find(
    (option) => option.value === value,
  )?.value;

  return (
    <Dropdown
      id={`${countryCode}-type`}
      label={label}
      value={optionValue || ''}
      onChange={handleTypeChange}
      data={{ automation: `rtw-dropdown-${countryCode}` }}
      placeholder={t('Select right to work...')}
      reserveMessageSpace={false}
      ref={rightToWorkRef}
    >
      {rightToWorkDropdownOptions.map(mapDropdownItemToOption)}
    </Dropdown>
  );
};
